import { render, staticRenderFns } from "./TaxationStatus.vue?vue&type=template&id=6d5adf70&"
import script from "./TaxationStatus.vue?vue&type=script&lang=js&"
export * from "./TaxationStatus.vue?vue&type=script&lang=js&"
import style0 from "./TaxationStatus.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports